import travelimage from '../assests/travelimage.jpg';
import carimage from '../assests/carimage.jpg';
import errorimage from '../assests/Errorimage.png';
import image2 from '../assests/image2.jpg';
import bgimage from '../assests/bgimage.png';
import phoneimage from '../assests/phoneimage.jpg';
import logo from '../assests/logo.jpeg';
import car1 from '../assests/car1.jpg';
import car2 from '../assests/car2.png';
import car3 from '../assests/car3.jpg';
import allstates from '../assests/allstates.jpeg';
import handshake from '../assests/handshake.jpeg';
import security from '../assests/security.jpg';
import earth from '../assests/earth.jpg';
import realcar1 from '../assests/realcar1.jpeg';
import realcar2 from '../assests/realcar2.jpeg';
import realcar3 from '../assests/realcar3.jpeg';
import realcar4 from '../assests/realcar4.jpeg';
import realcar5 from '../assests/realcar5.jpeg';
import faqbg from '../assests/faqbg.jpeg';
import swift from '../assests/swift.png';
import contactimage from '../assests/contactimage.png';
import Zablogomd from '../assests/Zablogomd.jpeg';
import punetomumbai from '../assests/punetomumbai.jpg';
import mumbaitopune from '../assests/mumbaitopune.jpg';

export default {
    travelimage,
    carimage,
    errorimage,
    image2,
    bgimage,
    phoneimage,
    logo,
    car1,
    car2,
    car3,
    allstates,
    handshake,
    security,
    earth,
    realcar1,
    realcar2,
    realcar3,
    realcar4,
    realcar5,
    faqbg,
    swift,
    contactimage,
    Zablogomd,
    punetomumbai,
    mumbaitopune
}